<template>
  <v-card
    class="mx-auto elevation-0"
    height="100%"
  >
    <v-toolbar
      class="kalan-titles elevation-0"
      color="primary--text"
    >
      <v-toolbar-title>
        <span>{{ $vuetify.lang.t(`$vuetify.${model}.plural_name`) }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div style="margin-right: 20px;">
        <v-text-field
          flat
          label="Buscar"
          hide-details
          v-model="search"
          append-icon="mdi-magnify"
        ></v-text-field>
      </div>
      <actions-button :item="{}" :actions="actions"></actions-button>
    </v-toolbar>
    <kalan-list
      :loading="loading"
      :getTitle="getTitle"
      :getSubTitle="getSubTitle"
      :getExtra="getExtra"
      :items="items"
      :search="search"
      :actions="listActions"
    >
    </kalan-list>
  </v-card>
</template>

<script>
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import ApiService from '@/util/api.service'
import Routes from '@/models/routes.model'
import Crud from '@/util/crud.service'
import RouteDevices from '../components/RouteDevices.vue'
// import Form from '@/components/form'

export default {
  props: {
    model: {
      default: 'routes'
    },
  },
  components: {
    'kalan-list': () => import('@/components/modulo/List.vue'),
    'actions-button': () => import('@/components/modulo/Actions.vue')
  },
  data() {
    return {
      items: [],
      loading: true,
      search: '',
      actions: [{
        help: window.VMA.$vuetify.lang.t(`$vuetify.${this.model}.create`),
        icon: 'mdi-plus',
        color: 'secondary',
        action: (item) => {
          Crud.create({
            item, schema: Routes, model: this.model, preSave: this.preSave, url: '/v2',
          }).then(this.load)
        }
      }],
      listActions: [{
        help: 'Dispositivos',
        icon: 'mdi-car-connected',
        color: 'orange',
        action: (item) => {
          new Vue({
            vuetify,
            ...RouteDevices,
            propsData: { route: item },
          }).$mount()
        }
      }, {
        help: window.VMA.$vuetify.lang.t(`$vuetify.${this.model}.update`),
        icon: 'mdi-pencil',
        color: 'accent',
        action: (item) => {
          Crud.update({
            item,
            schema: Routes,
            url: '/v2',
            model: this.model,
            title: this.getTitle(item),
            preSave: this.preSave
          }).then(this.load)
        }
      }, {
        help: window.VMA.$vuetify.lang.t(`$vuetify.${this.model}.read`),
        icon: 'mdi-eye',
        color: 'mattBlack',
        action: (item) => {
          Crud.read({
            item,
            schema: Routes,
            url: '/v2',
            model: this.model,
            title: this.getTitle(item)
          })
        }
      }, {
        help: window.VMA.$vuetify.lang.t(`$vuetify.${this.model}.delete`),
        icon: 'mdi-delete',
        color: 'red',
        action: (item) => {
          Crud.delete({
            id: item.id,
            url: '/v2',
            model: this.model,
            title: this.getTitle(item)
          }).then(this.load)
        }
      }],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    getTitle: (item) => item.name,
    getSubTitle: (item) => item.devices?.map((device) => device.name).join(', '),
    getExtra: () => null,
    preSave(item) {
      const it = Object.assign(item, {})
      return it
    },
    load() {
      this.loading = true
      ApiService({
        url: `/v2/${this.model}`,
        method: 'get',
      }).then((resp) => {
        this.items = resp.map((it) => {
          it.avatarColor = it.color
          return it
        })
        this.loading = false
      }).catch((err) => {
        this.loading = false
      })
    },
  }
}
</script>
